import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { EQLFunctionName } from 'v2/core/repository/eql/types';
import { shallow } from 'zustand/shallow';

export function useShouldAddDenominatorClause() {
  const { formulaID, denominatorWhereClause, compareTo } = useQuantifyStore(
    ({ query }) => {
      return {
        formulaID: query.formulaID,
        denominatorWhereClause: query.denominatorWhereClause,
        compareTo: query.compareTo,
      };
    },
    shallow,
  );

  return (
    formulaID === EQLFunctionName.NormaliseByPercent &&
    !compareTo &&
    denominatorWhereClause
  );
}
